/* Script della card prodotto (snippets/product-card.liquid): stesso motivo del CSS,
   vedi assets/zw-product-card.css. Caricato con defer in layout/theme.liquid. */
// Stato "salvato" dei cuori (.zw-wl-saved) e numero in navbar: script in
// snippets/header-left-logo-zerow.liquid, che c'e' su ogni pagina. Qui non
// bastava: il javascript di uno snippet arriva solo nelle pagine che lo
// rendono, e senza card il numero in navbar restava vuoto.
// Dopo un render di card nuove: window.zwWishlistSync().

// Cambio foto su hover: arriva sempre alla fine. Uscendo dalla card prima
// che la dissolvenza sia finita, .zw-hover resta fino al suo termine e solo
// dopo la foto torna indietro. Delegato su document: le card si
// ri-renderizzano a ogni filtro.
(function () {
  if (!window.matchMedia('(hover: hover)').matches) return;
  // ponytail: = --zw-fade-dur (dur-slow 500ms x 0.8) nel CSS qui sopra; se cambia la, cambia qui
  var FADE = 400;
  var SEL = '.collection-product-card.quickview--hover';
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest(SEL);
    if (!card || card.contains(e.relatedTarget)) return;
    clearTimeout(card.zwHoverTimer);
    // fascia specifiche ad altezza libera (composizione intera): i pallini salgono di quanto e' alta
    var specs = card.querySelector('.zw-card-specs');
    if (specs) card.querySelector('.card-wrapper').style.setProperty('--zw-specs-h', specs.offsetHeight + 'px');
    if (!card.classList.contains('zw-hover')) card.zwHoverStart = performance.now();
    card.classList.add('zw-hover');
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest(SEL);
    if (!card || card.contains(e.relatedTarget)) return;
    var wait = Math.max(0, FADE - (performance.now() - (card.zwHoverStart || 0)));
    card.zwHoverTimer = setTimeout(function () { card.classList.remove('zw-hover'); }, wait);
  });
})();

// Pallini colore della card (2026-10-20). La foto di ogni colore arriva con la
// pagina (data-variant-img + larghezza, snippets/product-variant-options.liquid): niente
// chiamata a /products/<handle>.js come faceva product-card.js (0,4 s + dissolvenza
// a ogni pallino). Il suo gestore del clic e' fermato qui sotto; custom.js
// (disponibilita' per colore) ascolta il change e resta com'e'.
// Passare sopra un pallino = sceglierlo (solo con mouse vero). Cambio foto in
// dissolvenza incrociata, solo a foto pronta: niente lampo mentre carica.
(function () {
  var SW = '.js-color-swatches input';
  var SWAP_MS = 300; // = transition di .zw-swap-layer nel CSS
  var WIDTHS = [360, 533, 720, 940, 1066]; // come la foto della card (product-card.liquid)

  // srcset costruito qui: nell'HTML un solo indirizzo per pallino invece di 5
  function srcsetOf(input) {
    var url = input && input.dataset.variantImg;
    if (!url) return '';
    var max = +input.dataset.variantImgW || WIDTHS[WIDTHS.length - 1];
    var ws = WIDTHS.filter(function (w) { return w <= max; });
    if (max < WIDTHS[WIDTHS.length - 1]) ws.push(max); // foto piccola: anche la sua misura piena
    return ws.map(function (w) { return url + '&width=' + w + ' ' + w + 'w'; }).join(', ');
  }

  // scarica in anticipo la foto di un colore (una volta sola per pallino)
  function preload(input, low) {
    if (!input || input.zwPre || !input.dataset.variantImg) return;
    var wrap = input.closest('.js-color-swatches-wrapper');
    var ref = wrap && wrap.querySelector('.media > img.media--first');
    var im = new Image();
    if (low) im.fetchPriority = 'low';
    if (ref) im.sizes = ref.sizes;
    im.srcset = srcsetOf(input);
    input.zwPre = im;
  }
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches(SW)) e.stopPropagation();
  }, true);

  // Dissolvenza incrociata: la foto nuova, gia' decodificata, entra in uno strato
  // sopra la vecchia (uno span, non un img: le regole img + img del tema la
  // tratterebbero come foto dell'hover); a fine dissolvenza la foto vera prende la
  // nuova sorgente e lo strato sparisce. Prima era una sfocatura del riquadro:
  // i bordi sfumati mostravano una cornice bianca (2026-10-20).
  function swap(wrap, srcset) {
    var img = wrap.querySelector('.media > img.media--first');
    if (!img || !srcset || img.getAttribute('srcset') === srcset) return;
    var media = img.parentElement;
    var token = {};
    media.zwToken = token;
    var cs = getComputedStyle(img);
    var next = new Image();
    next.alt = '';
    next.sizes = img.sizes;
    next.srcset = srcset;
    next.style.objectFit = cs.objectFit;
    next.style.transform = cs.transform; // stessa scala della foto (zoom dell'hover)
    var layer = document.createElement('span');
    layer.className = 'zw-swap-layer';
    layer.appendChild(next);
    (next.decode ? next.decode() : Promise.resolve()).catch(function () {}).then(function () {
      if (media.zwToken !== token) return;
      media.querySelectorAll('.zw-swap-layer').forEach(function (l) { l.remove(); });
      media.appendChild(layer);
      layer.getBoundingClientRect(); // parte da opacity 0
      layer.classList.add('is-in');
      setTimeout(function () {
        if (media.zwToken !== token) return;
        var second = media.querySelector('img.media--second');
        if (second) second.remove(); // foto hover di un altro colore
        img.srcset = srcset;
        img.src = srcset.split(', ').pop().split(' ')[0];
        (img.decode ? img.decode() : Promise.resolve()).catch(function () {}).then(function () {
          if (media.zwToken === token) layer.remove();
        });
      }, calm ? 0 : SWAP_MS);
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches(SW)) return;
    var wrap = input.closest('.js-color-swatches-wrapper');
    if (!wrap) return;
    // link della card e "+N" (snippets/product-card.liquid) puntano alla stessa variante
    if (input.dataset.variantLink) {
      wrap.querySelectorAll('.js-color-swatches-link, a.zw-swatch-count').forEach(function (a) {
        a.href = input.dataset.variantLink;
      });
    }
    var id = wrap.querySelector('.card__add-to-cart input[name="id"]');
    if (id && input.dataset.variantId) id.value = input.dataset.variantId;
    swap(wrap, srcsetOf(input));
  });

  if (!window.matchMedia('(hover: hover)').matches) return;
  var timer;
  var rowTimer;
  document.addEventListener('mouseover', function (e) {
    var row = e.target.closest('.js-color-swatches');
    if (row && !row.zwPreloaded && !rowTimer) {
      // mouse fermo sulla fila per 150 ms: si scaricano, a bassa priorita', le foto dei
      // soli pallini VISIBILI (quelli dietro "+N" sono display:none, offsetParent null).
      // Attraversando la griglia di passaggio non parte niente.
      rowTimer = setTimeout(function () {
        rowTimer = null;
        if (!row.matches(':hover')) return;
        row.zwPreloaded = true;
        row.querySelectorAll('label.color-swatch').forEach(function (l) {
          if (l.offsetParent) preload(document.getElementById(l.htmlFor), true);
        });
      }, 150);
    }
    var label = e.target.closest('.js-color-swatches label.color-swatch');
    if (!label) return;
    preload(document.getElementById(label.htmlFor), false); // quello sotto il mouse: subito
    clearTimeout(timer);
    timer = setTimeout(function () {
      var input = document.getElementById(label.htmlFor);
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 60);
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('.js-color-swatches label.color-swatch')) clearTimeout(timer);
    var row = e.target.closest('.js-color-swatches');
    if (row && !row.contains(e.relatedTarget)) {
      clearTimeout(rowTimer);
      rowTimer = null;
    }
  });
})();
